import { FormEvent, useState } from "react";
import { FilterActions } from "./FilterActions.tsx";
import { DateRange, isEmptyDateRange } from "../dateRange.ts";

const inputClassName =
  "w-full rounded-md border border-slate-300 px-2 py-1.5 text-sm text-slate-700 focus:outline-none focus:border-slate-500";

export function DateRangeFilter({
  value,
  onApply,
  close,
}: {
  value: DateRange;
  onApply: (range: DateRange) => void;
  close: () => void;
}) {
  const [draft, setDraft] = useState(value);

  function apply(range: DateRange) {
    onApply(range);
    close();
  }

  function applyDraft(event: FormEvent) {
    event.preventDefault();
    apply(draft);
  }

  return (
    <form onSubmit={applyDraft} className="flex flex-col gap-2 px-2">
      <div className="grid grid-cols-2 gap-2">
        <label className="flex flex-col gap-1 text-xs text-slate-500">
          From
          <input
            type="date"
            value={draft.from ?? ""}
            max={draft.to}
            onChange={(event) =>
              setDraft({ ...draft, from: event.target.value || undefined })
            }
            className={inputClassName}
          />
        </label>
        <label className="flex flex-col gap-1 text-xs text-slate-500">
          To
          <input
            type="date"
            value={draft.to ?? ""}
            min={draft.from}
            onChange={(event) =>
              setDraft({ ...draft, to: event.target.value || undefined })
            }
            className={inputClassName}
          />
        </label>
      </div>
      <FilterActions
        canClear={!isEmptyDateRange(value)}
        onClear={() => apply({})}
      />
    </form>
  );
}
